import { render, staticRenderFns } from "./TourAddGame.vue?vue&type=template&id=46ba90b6&scoped=true&"
import script from "./TourAddGame.vue?vue&type=script&lang=js&"
export * from "./TourAddGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba90b6",
  null
  
)

export default component.exports